import { render, staticRenderFns } from "./QuickView.vue?vue&type=template&id=63ca3bf8&"
import script from "./QuickView.vue?vue&type=script&lang=js&"
export * from "./QuickView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports